define([
    "skylark-utils/mover"
], function(mover) {
    return mover;
});
